import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { CurrencyCode as CurrencyCodeProto } from '@square/dashboard-protos/models/squareup/common/currency_codes';
import Enum from '@square/dashboard-utilities/utils/enum';
export const CurrencyCode = new Enum(Object.keys(CurrencyCodeProto));
export default ProtoBaseModel.extend({
  amount: attr(Number, {
    defaultValue: 0
  }),
  currencyCode: attr(CurrencyCode, {
    defaultValue: CurrencyCode.USD
  })
});